<template>
  <div style="height: 100%; display: flex; flex-direction: column;">
    <div ref="AIAssistantMainScroll" style="height: 90%; width: 100%; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
      <v-card v-for="AIAssistantMessage in display.AIAssistantConversation" v-bind:key="AIAssistantMessage" :color="AIAssistantMessage.AIAssistantMessageOwner == 'user' ? 'tertiary' : 'secondary'" elevation="0" rounded="lg" style="margin: 10px; padding: 10px; width: 80%;" :style="AIAssistantMessage.AIAssistantMessageOwner == 'user' ? 'margin-left: auto; text-align: right;' : 'margin-right: auto; text-align: left;'" class="messageAnimation">
        <p>{{ AIAssistantMessage.AIAssistantMessageBody }}</p>
        <div v-if="AIAssistantMessage.AIAssistantMessageOwner == 'user'" style="display: flex; justify-content: flex-start; margin-top: 5px; align-items: center; gap: 5px; cursor: default; user-select: none;">
          <v-icon size="x-small" color="secondary" class="hoverableElement" style="cursor: default;">mdi-account</v-icon>
          <p style="margin: 0; font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(AIAssistantMessage.AIAssistantMessageDatetime) }}</p>
        </div>
        <div v-else style="display: flex; justify-content: flex-end; margin-top: 5px; align-items: center; gap: 5px; cursor: default; user-select: none;"> 
          <p style="margin: 0; font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(AIAssistantMessage.AIAssistantMessageDatetime) }}</p>
          <v-icon size="x-small" color="tertiary" class="hoverableElement" style="cursor: default;">mdi-robot</v-icon>
        </div>
      </v-card>
      <v-card v-if="display.AIAssistantConversation.length == 0 && navigation.AIAssistantStatus != 'thinking'" color="secondary" elevation="0" rounded="lg" style="margin: 10px; padding: 10px; width: 80%;" class="messageAnimation">
        <p>Hola, soy SOUQ AI, ¿en qué puedo ayudarte?</p>
        <div style="display: flex; justify-content: flex-end; margin-top: 5px; align-items: center; gap: 5px; cursor: default; user-select: none;"> 
          <p style="margin: 0; font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(new Date()) }}</p>
          <v-icon size="x-small" color="tertiary" class="hoverableElement" style="cursor: default;">mdi-robot</v-icon>
        </div>
      </v-card>
      <v-card v-if="navigation.AIAssistantStatus == 'thinking'" color="secondary" elevation="0" rounded="lg" style="margin: 10px; padding: 10px; width: 80%; display: flex; justify-content: center; align-items: center; user-select: none; cursor: default;" class="messageAnimation">
        <v-icon size="x-large" color="tertiary" class="pulseElement">mdi-robot</v-icon>
        <span style="margin-left: 8px; font-size: 1.2em;">{{ animation.AIAssistantTypingAnimationDots }}</span>
      </v-card>
    </div>
    <div style="width: 100%; margin-top: auto; padding: 10px;">
      <v-textarea
        ref="AIAssistantMessageInput"
        v-model="input.AIAssistantMessage"
        :append-inner-icon="input.AIAssistantMessage && /\S/.test(input.AIAssistantMessage) ? 'mdi-send' : ''"
        @click:append-inner="sendAIAssistantMessage()"
        @keydown="handleAIAssistantMessageInputEnter($event)"
        color="secondary"
        variant="solo-filled"
        density="compact"
        rows="2"
        auto-grow
        hide-details
        auto-complete="off"
      ></v-textarea>
      <div style="text-align: right; font-size: x-small; color: #999; margin-top: 5px; display: flex; align-items: center; justify-content: flex-end; gap: 5px; cursor: default; user-select: none;">
        <span>Powered by</span>
        <img :src="$assets.default.images.openai" draggable="false" alt="SOUQ" style="height: 12px; width: auto; filter: invert(1);">
      </div>
    </div>
  </div>
</template>
  
<style scoped>

  .messageAnimation {
    animation: messageAnimation 0.3s ease-in-out;
    transform-origin: center;
  }

  @keyframes messageAnimation {
    0% {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

</style>

<script>
  import componentConnector from '@/utilities/componentConnector';
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: { },
    data: () => ({
      input: 
      {
        AIAssistantMessage: null,
      },

      display: 
      {
        AIAssistantConversation: []
      },

      navigation: 
      {
        AIAssistantStatus: 'idle',
        AIAssistantMainScrollInterval: null
      },

      animation:
      {
        AIAssistantTypingAnimationInterval: null,
        AIAssistantTypingAnimationTimer: 0,
        AIAssistantTypingAnimationDots: ''
      },

      systemInformationData:
      {
        CRMAccountID: null,
        CRMAgentID: null
      },
    }),
    methods: {
      
      async sendAIAssistantMessage(){
        this.startAIAssistantTypingAnimation();
        const sendAIAssitantMessageRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'AIAssistantMessage': this.input.AIAssistantMessage,
          'AIAssistantConversation': this.display.AIAssistantConversation.slice(-20).map(AIAssistantMessage => ({'role': AIAssistantMessage.AIAssistantMessageOwner, 'content': AIAssistantMessage.AIAssistantMessageBody}))
        }
        this.display.AIAssistantConversation.push({
          'AIAssistantMessageBody': this.input.AIAssistantMessage,
          'AIAssistantMessageOwner': 'user',
          'AIAssistantMessageDatetime': new Date()
        });
        const sendAIAssitantMessageResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/AIAssistant/functions/sendAIAssistantMessage', sendAIAssitantMessageRequestQuery);
        if (sendAIAssitantMessageResult.success){
          this.display.AIAssistantConversation.push({
            'AIAssistantMessageBody': sendAIAssitantMessageResult.result,
            'AIAssistantMessageOwner': 'system',
            'AIAssistantMessageDatetime': new Date()
          });
          this.input.AIAssistantMessage = null;
          this.AIAssistantMainScrollToBottom();
        } else {
          this.display.AIAssistantConversation.pop();
          this.$root.notificationDialog.showSystemNotificationDialog('sendAIAssitantMessage_error', 'error', 'Ha ocurrido un error inesperado al enviar el mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.stopAIAssistantTypingAnimation();
        this.$generalFunctions.default.focusInput(this, 'AIAssistantMessageInput');
      },

      stopAIAssistantTypingAnimation() {
        if (this.animation.AIAssistantTypingAnimationInterval) clearInterval(this.animation.AIAssistantTypingAnimationInterval);
        this.navigation.AIAssistantStatus = 'idle';
        this.animation.AIAssistantTypingAnimationInterval = null;
        this.animation.AIAssistantTypingAnimationTimer = 0;
        this.animation.AIAssistantTypingAnimationDots = '';
      },

      startAIAssistantTypingAnimation() {
        this.navigation.AIAssistantStatus = 'thinking';
        this.animation.AIAssistantTypingAnimationInterval = setInterval(() => {
          this.animation.AIAssistantTypingAnimationTimer++;
          this.animation.AIAssistantTypingAnimationDots = this.animation.AIAssistantTypingAnimationDots.length >= 3 ? '' : this.animation.AIAssistantTypingAnimationDots + '.';
        }, 500);
      },

      handleMainKeyDown(keyEvent) {
        const AIAssistantMainScroll = this.$refs.AIAssistantMainScroll;
        const AIAssistantMessageInput = this.$refs.AIAssistantMessageInput;
        if (!AIAssistantMainScroll || !AIAssistantMessageInput) return;
        if (AIAssistantMessageInput.contains(keyEvent.target)) return;
        if (keyEvent.key == "ArrowUp") {
          AIAssistantMainScroll.scrollTop = 0;
        } else if (keyEvent.key == "ArrowDown") {
          AIAssistantMainScroll.scrollTop = AIAssistantMainScroll.scrollHeight;
        }
      },

      AIAssistantMainScrollToBottom(){
        if (this.navigation.AIAssistantMainScrollInterval) clearInterval(this.navigation.AIAssistantMainScrollInterval);
        this.$nextTick(() => {
          const AIAssistantMainScroll = this.$refs.AIAssistantMainScroll;
          if (!AIAssistantMainScroll) return;
          
          let lastScrollHeight = 0;
          let attempts = 0;
          this.navigation.AIAssistantMainScrollInterval = setInterval(() => {
            const currentScrollHeight = AIAssistantMainScroll.scrollHeight;
            if (currentScrollHeight != lastScrollHeight) {
              lastScrollHeight = currentScrollHeight;
              AIAssistantMainScroll.scrollTop = AIAssistantMainScroll.scrollHeight;
            } else {
              clearInterval(this.navigation.AIAssistantMainScrollInterval);
            }
            attempts = attempts + 1;
            if (attempts > 25) {
              clearInterval(this.navigation.AIAssistantMainScrollInterval);
            }
          }, 10);
        });
      },

      handleAIAssistantMessageInputEnter(handleAIAssistantMessageInputEnterEvent){
        const regularExpressionChecker = /\S/;
        if (handleAIAssistantMessageInputEnterEvent.key == 'Enter' && !handleAIAssistantMessageInputEnterEvent.shiftKey && this.input.AIAssistantMessage != null && regularExpressionChecker.test(this.input.AIAssistantMessage)){
          handleAIAssistantMessageInputEnterEvent.preventDefault();
          this.sendAIAssistantMessage();
        }
      },

      focusInput(){
        this.$generalFunctions.default.focusInput(this, 'AIAssistantMessageInput');
      },

      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('AIAssistant_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('AIAssistant_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
    },
    
    
    
    
    mounted(){
      componentConnector.componentConnection.on('readCRMWhatsappConversation', this.handleReadCRMWhatsappConversation);
      window.addEventListener('keydown', this.handleMainKeyDown);
      this.getSystemInformation();
    },
    
    
    beforeUnmount(){
      componentConnector.componentConnection.off('readCRMWhatsappConversation', this.handleReadCRMWhatsappConversation);
      window.removeEventListener('keydown', this.handleMainKeyDown);
      this.stopAIAssistantTypingAnimation();
    }
  }
</script>